import React from 'react';
import { Step } from 'components/SteppedModal';
import useSocialShareModalFooter from 'containers/SocialShareModal/SocialShareModalFooter';
import { InstagramPostType, InstagramSocialShareStep } from '../../types';
import InstagramPostComposerStep from './InstagramPostComposerStep';

export type UseInstagramPostComposerStepConfig = {
  postType: InstagramPostType;
  onPostTypeChange: (postType: InstagramPostType) => void;
  onShare: () => void;
};

export default function useInstagramPostComposerStep({
  postType,
  onPostTypeChange,
  onShare,
}: UseInstagramPostComposerStepConfig): Step<InstagramSocialShareStep> {
  const footerConfig = useSocialShareModalFooter({
    onShare,
  });

  return {
    ...footerConfig,
    id: 'composer',
    component: (
      <InstagramPostComposerStep {...{ postType, onPostTypeChange }} />
    ),
  };
}
